import { render } from "./ListSubscriptionPlans.vue?vue&type=template&id=1af4aa16"
import script from "./ListSubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./ListSubscriptionPlans.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__